import {
    getContext as svelteGetContext,
    setContext as svelteSetContext,
} from "svelte";

/**
 * Provided as key to getContext and setContext in order to enable strict typing
 */
// eslint-disable-next-line @typescript-eslint/no-empty-interface, @typescript-eslint/no-unused-vars
export interface InjectionKey<T = unknown> {}

type setContext = <T>(key: InjectionKey<T>, context: T) => void;

const getTypedContext = <T>(key: InjectionKey<T>): T => {
    const val = svelteGetContext(key);
    if (val === undefined || val === null) {
        throw new Error(`Access to unset context: ${key.toString()}`);
    }
    return val as T;
};
export { getTypedContext };

export const setTypedContext = svelteSetContext as setContext;
